export default __webpack_public_path__ + "static/augmented_mob-8d6dec49179340775fb1a76299dba033.webp";